export default {
    data() {
        return {
            isInactive: false,
            userActivityThrottlerTimeout: null,
            userActivityTimeout: null,
            inactiveUserTimeThreshold: 600000,
            userActivityThrottlerTime: 1000,
            once: false,
        };
    },
    beforeMount() {
        this.activateActivityTracker();
    },

    beforeDestroy() {
        this.deactivateActivityTracker();
        clearTimeout(this.userActivityTimeout);
        clearTimeout(this.userActivityThrottlerTimeout);
    },

    methods: {
        activateActivityTracker() {
            window.addEventListener("click", this.userActivityThrottler);
            window.addEventListener("mousemove", this.userActivityThrottler);
            window.addEventListener("scroll", this.userActivityThrottler);
            window.addEventListener("keydown", this.userActivityThrottler);
            window.addEventListener("resize", this.userActivityThrottler);
        },

        deactivateActivityTracker() {
            window.removeEventListener("click", this.userActivityThrottler);
            window.removeEventListener("mousemove", this.userActivityThrottler);
            window.removeEventListener("scroll", this.userActivityThrottler);
            window.removeEventListener("keydown", this.userActivityThrottler);
            window.removeEventListener("resize", this.userActivityThrottler);
        },

        resetUserActivityTimeout() {
            clearTimeout(this.userActivityTimeout);

            this.userActivityTimeout = setTimeout(() => {
                this.userActivityThrottler();
                this.isInactive = true;
                this.inactiveUserAction();
                if (this.once) {
                    clearTimeout(this.userActivityTimeout);
                    clearTimeout(this.userActivityThrottlerTimeout);
                }
            }, this.inactiveUserTimeThreshold);
        },

        userActivityThrottler() {
            if (this.isInactive) {
                this.isInactive = false;
            }

            if (!this.userActivityThrottlerTimeout) {
                this.userActivityThrottlerTimeout = setTimeout(() => {
                    this.resetUserActivityTimeout();
                    clearTimeout(this.userActivityThrottlerTimeout);
                    this.userActivityThrottlerTimeout = null;
                }, this.userActivityThrottlerTime);
            }
        },

        //override this method
        inactiveUserAction() {
            console.log('user inactive');
        }
    },
};